import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import '@/env/index'
import App from '@/App'
import { LoadingDots } from '@/components'
import '@/localization/i18n'

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)

root.render(
  <StrictMode>
    <Suspense fallback={<LoadingDots fullScreen />}>
      <App />
    </Suspense>
  </StrictMode>
)
